import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from '../utils/apiHelper';

import { useBranding } from '../context/BrandingContext';
import '../styles/login.css';
import { showSuccess, showError } from '../utils/toastHelper';

const ForgotPassword = () => {
  const { branding, loading: brandingLoading } = useBranding();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await apiRequest('/auth/request-password-reset', {
        method: 'POST',
        data: { email },
        skipAuth: true
      });

      setSubmitted(true);
      showSuccess('Sıfırlama bağlantısı e-posta adresinize gönderildi.');
    } catch (error) {
      console.error('Password reset request error:', error);
      showError(error.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  if (brandingLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: '#f8f9fc' }}>
        <div className="spinner-border" style={{ color: '#aaa' }} role="status" />
      </div>
    );
  }

  const companyName = branding.name || '';
  const logoSrc = branding.logoUrl || branding.companyLogo || null;
  const accent = branding.brandColor || '#1e293b';
  const accentSoft = accent + '18';
  const heroTitle = branding.heroTitle || '';
  const heroSub = branding.heroSubtitle || branding.tagline || '';

  return (
    <div className="login-page">
      {/* ── Left: Branded Panel ─────────────────────────────── */}
      <div className="login-brand-panel" style={{ '--accent': accent, '--accent-soft': accentSoft }}>
        <div className="login-brand-bg" />
        <div className="login-brand-content">
          {logoSrc && (
            <img src={logoSrc} alt={companyName || 'Logo'} className="login-brand-logo" />
          )}
          {heroTitle && <h1 className="login-brand-title">{heroTitle}</h1>}
          {heroSub && <p className="login-brand-subtitle">{heroSub}</p>}
          {!logoSrc && !heroTitle && companyName && companyName !== 'System Admin Company' && (
            <h1 className="login-brand-title">{companyName}</h1>
          )}
        </div>
      </div>

      {/* ── Right: Form ─────────────────────────────────────── */}
      <div className="login-form-panel">
        <div className="login-form-wrapper">
          {/* Mobile-only header */}
          <div className="login-mobile-header" style={{ '--accent': accent }}>
            {logoSrc ? (
              <img src={logoSrc} alt={companyName || 'Logo'} className="login-mobile-logo" />
            ) : companyName && companyName !== 'System Admin Company' ? (
              <span className="login-mobile-name" style={{ color: accent }}>{companyName}</span>
            ) : null}
          </div>

          <div className="login-form-inner">
            <h2 className="login-form-title">Şifremi Unuttum</h2>
            <p className="login-form-desc">
              E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
            </p>

            {!submitted ? (
              <form onSubmit={handleSubmit} className="login-form mt-4">
                <div className="login-field">
                  <label className="login-label" htmlFor="email">E-posta</label>
                  <div className="login-input-wrap" style={{ '--accent': accent }}>
                    <i className="fas fa-envelope login-input-icon" />
                    <input
                      id="email"
                      type="email"
                      className="login-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                      placeholder="ornek@email.com"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="login-submit mt-4"
                  style={{ '--accent': accent }}
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : (
                    <i className="fas fa-paper-plane me-2"></i>
                  )}
                  Bağlantı Gönder
                </button>
              </form>
            ) : (
              <div className="alert alert-success mt-4 p-4 text-center rounded-4 border-0" style={{ backgroundColor: '#d1e7dd', color: '#0f5132' }}>
                <i className="fas fa-check-circle fa-3x mb-3"></i>
                <h5 className="alert-heading fw-bold">Bağlantı Gönderildi!</h5>
                <p className="mb-0 small">
                  Şifre sıfırlama bağlantısı <strong>{email}</strong> adresine gönderildi. Lütfen gelen kutunuzu (ve gerekiyorsa spam klasörünü) kontrol edin.
                </p>
              </div>
            )}

            <div className="d-flex justify-content-center mt-5">
              <Link to="/login" className="login-link fw-semibold" style={{ color: accent }}>
                <i className="fas fa-arrow-left me-2"></i> Giriş sayfasına dön
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
